import React from 'react';
import classNames from 'classnames';
import styles from './Table.module.scss';

interface TableRowProps {
  children: React.ReactNode;
  className?: string;
}

export function TableRow({children, className}: TableRowProps) {
  return (
    <div className={classNames(styles.tableRow, className)}>{children}</div>
  );
}

export default TableRow;
